import { useFormContext } from "react-hook-form";
import FieldOpenMapRadius from "../../../Maps/FieldOpenMapRadius";
import {
  CREATE_CAMPAIGN_SECTION_HELPER_SX,
  CREATE_CAMPAIGN_SECTION_TEXT_SX,
} from "../createAdsCampaignWizardConstants";

const LOCATION_SECTION_TEXT_SX = {
  "& button .MuiTypography-body2": CREATE_CAMPAIGN_SECTION_TEXT_SX,
  "& button .MuiTypography-caption": CREATE_CAMPAIGN_SECTION_HELPER_SX,
};

const StepLocations = () => {
  const { watch, setValue } = useFormContext();

  return (
    <FieldOpenMapRadius
      name="locations"
      titleLabel=""
      campaignContext={watch("context")}
      onCallbackSave={(locations) => setValue("locations", locations)}
      sx={LOCATION_SECTION_TEXT_SX}
    />
  );
};

export default StepLocations;
